module.exports = __webpack_public_path__ + "static/img/1772_phase_function_Paper_PointsHejduk_Prediction.b1c49a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1772_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Acug
// module chunks = 0